import React from "react";
export const XBEmenuProducts = ({
  shown,
  nahdleHide,
  alsoLinks = true,
}) => {



  return (<div className="m" data-menu="target">
    <div data-menu="trigger" className="mz" />
    <div data-menu="target" className="mm">
      <div className="embed_menu_inside w-embed">
        <style dangerouslySetInnerHTML={{
          __html: "\n.m_prod_card:hover .m_prod_ctas {\n\topacity: 1;\n\ttransform: translateY(8px);\n}\n\n.m_prod_card:hover .x_angles4 {\n\topacity: 1;\n\ttransform: scale(1);\n}\n\n"
        }} />
      </div>
      <div data-menu-pop="products" className="mm_inner">
        <div className="m_prod_ul0">
          <div data-menu="target" className="m_prod_ul">
            <div className="m_prod_card">
              <div className="m_prod_card1">
                <div className="m_prod_cta1">
                  <div className="m_prod_name">
                    <div className="m_prod_ico">
                      <img src="https://assets.website-files.com/5b1f8af32d51d9c88592d929/5d78ebd8d1e17a8128cd42b1_sb_icon.svg" width={30} height={30} />
                    </div>
                    <div className="m_prod">
                      <div className="m_prod_title">Site Builder</div>
                      <div className="m_prod_desc">
                        Custom, secure website
                    </div>
                    </div>
                  </div>
                </div>
                <div className="m_prod_ctas">
                  <div className="m_prod_cta1">
                    <div className="m_prod_link0">
                      <div className="m_prod_link_ico w-embed">
                        <svg width={17} height={16} viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path fillRule="evenodd" clipRule="evenodd" d="M15.3615 7.03238L10.3291 2L9.52481 2.80429L13.9984 7.27783H0V8.27783H14.116L9.52481 12.8691L10.3291 13.6733L16.1705 7.83198L15.3662 7.02769L15.3615 7.03238Z" fill="#0073F7" />
                        </svg>
                      </div>
                      <div className="m_prod_link">Self Integrate</div>
                    </div>
                  </div>
                  <div className="m_prod_cta1">
                    <div className="m_prod_link0">
                      <div className="m_prod_link_ico w-embed">
                        <svg width={17} height={16} viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path fillRule="evenodd" clipRule="evenodd" d="M15.3615 7.03238L10.3291 2L9.52481 2.80429L13.9984 7.27783H0V8.27783H14.116L9.52481 12.8691L10.3291 13.6733L16.1705 7.83198L15.3662 7.02769L15.3615 7.03238Z" fill="#0073F7" />
                        </svg>
                      </div>
                      <div className="m_prod_link">Documentation</div>
                    </div>
                  </div>
                </div>
                <div className="x_angles4" />
              </div>
            </div>
            <div className="m_prod_card">
              <div className="m_prod_card1">
                <div className="m_prod_cta1">
                  <div className="m_prod_name">
                    <div className="m_prod_ico">
                      <img src="https://assets.website-files.com/5b1f8af32d51d9c88592d929/5d78eb8bd1e17a7813cd41b9_launcher_icon.svg" width={30} height={30} />
                    </div>
                    <div className="m_prod">
                      <div className="m_prod_title">Launcher</div>
                      <div className="m_prod_desc">
                        Player options HQ
                      <span className="t_b2_px t_b2_px--link" />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="m_prod_ctas">
                  <div className="m_prod_cta1">
                    <div className="m_prod_link0">
                      <div className="m_prod_link_ico w-embed">
                        <svg width={17} height={16} viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path fillRule="evenodd" clipRule="evenodd" d="M15.3615 7.03238L10.3291 2L9.52481 2.80429L13.9984 7.27783H0V8.27783H14.116L9.52481 12.8691L10.3291 13.6733L16.1705 7.83198L15.3662 7.02769L15.3615 7.03238Z" fill="#0073F7" />
                        </svg>
                      </div>
                      <div className="m_prod_link">Self Integrate</div>
                    </div>
                  </div>
                  <div className="m_prod_cta1">
                    <div className="m_prod_link0">
                      <div className="m_prod_link_ico w-embed">
                        <svg width={17} height={16} viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path fillRule="evenodd" clipRule="evenodd" d="M15.3615 7.03238L10.3291 2L9.52481 2.80429L13.9984 7.27783H0V8.27783H14.116L9.52481 12.8691L10.3291 13.6733L16.1705 7.83198L15.3662 7.02769L15.3615 7.03238Z" fill="#0073F7" />
                        </svg>
                      </div>
                      <div className="m_prod_link">Documentation</div>
                    </div>
                  </div>
                </div>
                <div className="x_angles4" />
              </div>
            </div>
            <div className="m_prod_card">
              <div className="m_prod_card1">
                <div className="m_prod_cta1">
                  <div className="m_prod_name">
                    <div className="m_prod_ico">
                      <img src="https://assets.website-files.com/5b1f8af32d51d9c88592d929/5d91a28d124e072bfe1cfd18_Direct%20Sales%20.svg" width={30} height={30} />
                    </div>
                    <div className="m_prod">
                      <div className="m_prod_title">Buy Button</div>
                      <div className="m_prod_desc">Sales made simple</div>
                    </div>
                  </div>
                </div>
                <div className="x_angles4" />
                <div className="m_prod_ctas">
                  <div className="m_prod_cta1">
                    <div className="m_prod_link0">
                      <div className="m_prod_link_ico w-embed">
                        <svg width={17} height={16} viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path fillRule="evenodd" clipRule="evenodd" d="M15.3615 7.03238L10.3291 2L9.52481 2.80429L13.9984 7.27783H0V8.27783H14.116L9.52481 12.8691L10.3291 13.6733L16.1705 7.83198L15.3662 7.02769L15.3615 7.03238Z" fill="#0073F7" />
                        </svg>
                      </div>
                      <div className="m_prod_link">Self Integrate</div>
                    </div>
                  </div>
                  <div className="m_prod_cta1">
                    <div className="m_prod_link0">
                      <div className="m_prod_link_ico w-embed">
                        <svg width={17} height={16} viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path fillRule="evenodd" clipRule="evenodd" d="M15.3615 7.03238L10.3291 2L9.52481 2.80429L13.9984 7.27783H0V8.27783H14.116L9.52481 12.8691L10.3291 13.6733L16.1705 7.83198L15.3662 7.02769L15.3615 7.03238Z" fill="#0073F7" />
                        </svg>
                      </div>
                      <div className="m_prod_link">Documentation</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="m_prod_card">
              <div className="m_prod_card">
                <div className="m_prod_card1">
                  <div className="m_prod_cta1">
                    <div className="m_prod_name">
                      <div className="m_prod_ico">
                        <img src="https://assets.website-files.com/5b1f8af32d51d9c88592d929/5d78eb35afed040902873aa8_pn_icon.svg" width={30} height={30} />
                      </div>
                      <div className="m_prod">
                        <div className="m_prod_title">Partner Network</div>
                        <div className="m_prod_desc">
                          User acquisition{" "}
                          <span className="t_b2_px t_b2_px--link" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="x_angles4" />
                </div>
                <div className="m_prod_ctas">
                  <div className="m_prod_cta1">
                    <div className="m_prod_link0">
                      <div className="m_prod_link_ico w-embed">
                        <svg width={17} height={16} viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path fillRule="evenodd" clipRule="evenodd" d="M15.3615 7.03238L10.3291 2L9.52481 2.80429L13.9984 7.27783H0V8.27783H14.116L9.52481 12.8691L10.3291 13.6733L16.1705 7.83198L15.3662 7.02769L15.3615 7.03238Z" fill="#0073F7" />
                        </svg>
                      </div>
                      <div className="m_prod_link">Self Integrate</div>
                    </div>
                  </div>
                  <div className="m_prod_cta1">
                    <div className="m_prod_link0">
                      <div className="m_prod_link_ico w-embed">
                        <svg width={17} height={16} viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path fillRule="evenodd" clipRule="evenodd" d="M15.3615 7.03238L10.3291 2L9.52481 2.80429L13.9984 7.27783H0V8.27783H14.116L9.52481 12.8691L10.3291 13.6733L16.1705 7.83198L15.3662 7.02769L15.3615 7.03238Z" fill="#0073F7" />
                        </svg>
                      </div>
                      <div className="m_prod_link">Documentation</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="m_prod_card">
              <div className="m_prod_card1">
                <div className="m_prod_cta1">
                  <div className="m_prod_name">
                    <div className="m_prod_ico">
                      <img src="https://assets.website-files.com/5b1f8af32d51d9c88592d929/5d78ebaf285c184ae1166506_login_icon.svg" width={30} height={30} />
                    </div>
                    <div className="m_prod">
                      <div className="m_prod_title">Login</div>
                      <div className="m_prod_desc">
                        Single, secure sign-on
                    </div>
                    </div>
                  </div>
                </div>
                <div className="x_angles4" />
                <div className="x_angles4" />
                <div className="m_prod_ctas">
                  <div className="m_prod_cta1">
                    <div className="m_prod_link0">
                      <div className="m_prod_link_ico w-embed">
                        <svg width={17} height={16} viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path fillRule="evenodd" clipRule="evenodd" d="M15.3615 7.03238L10.3291 2L9.52481 2.80429L13.9984 7.27783H0V8.27783H14.116L9.52481 12.8691L10.3291 13.6733L16.1705 7.83198L15.3662 7.02769L15.3615 7.03238Z" fill="#0073F7" />
                        </svg>
                      </div>
                      <div className="m_prod_link">Self Integrate</div>
                    </div>
                  </div>
                  <div className="m_prod_cta1">
                    <div className="m_prod_link0">
                      <div className="m_prod_link_ico w-embed">
                        <svg width={17} height={16} viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path fillRule="evenodd" clipRule="evenodd" d="M15.3615 7.03238L10.3291 2L9.52481 2.80429L13.9984 7.27783H0V8.27783H14.116L9.52481 12.8691L10.3291 13.6733L16.1705 7.83198L15.3662 7.02769L15.3615 7.03238Z" fill="#0073F7" />
                        </svg>
                      </div>
                      <div className="m_prod_link">Documentation</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="m_prod_card">
              <div className="m_prod_card1">
                <div className="m_prod_cta1">
                  <div className="m_prod_name">
                    <div className="m_prod_ico">
                      <img src="https://assets.website-files.com/5b1f8af32d51d9c88592d929/5d91a275124e0747601cfbc0_IN-GAME%20STORE%20.svg" width={30} height={30} />
                    </div>
                    <div className="m_prod">
                      <div className="m_prod_title">Player Inventory</div>
                      <div className="m_prod_desc">
                        Cloud item storage
                      <span className="t_b2_px t_b2_px--link" />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="x_angles4" />
                <div className="m_prod_ctas">
                  <div className="m_prod_cta1">
                    <div className="m_prod_link0">
                      <div className="m_prod_link_ico w-embed">
                        <svg width={17} height={16} viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path fillRule="evenodd" clipRule="evenodd" d="M15.3615 7.03238L10.3291 2L9.52481 2.80429L13.9984 7.27783H0V8.27783H14.116L9.52481 12.8691L10.3291 13.6733L16.1705 7.83198L15.3662 7.02769L15.3615 7.03238Z" fill="#0073F7" />
                        </svg>
                      </div>
                      <div className="m_prod_link">Self Integrate</div>
                    </div>
                  </div>
                  <div className="m_prod_cta1">
                    <div className="m_prod_link0">
                      <div className="m_prod_link_ico w-embed">
                        <svg width={17} height={16} viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path fillRule="evenodd" clipRule="evenodd" d="M15.3615 7.03238L10.3291 2L9.52481 2.80429L13.9984 7.27783H0V8.27783H14.116L9.52481 12.8691L10.3291 13.6733L16.1705 7.83198L15.3662 7.02769L15.3615 7.03238Z" fill="#0073F7" />
                        </svg>
                      </div>
                      <div className="m_prod_link">Documentation</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="m_prod_card">
              <div className="m_prod_card1">
                <div className="m_prod_cta1">
                  <div className="m_prod_name">
                    <div className="m_prod_ico">
                      <img src="https://assets.website-files.com/5b1f8af32d51d9c88592d929/5d91a8c1d12b5be625a7ffb4_subscriptions1.svg" width={32} height={32} />
                    </div>
                    <div className="m_prod">
                      <div className="m_prod_title">Subscriptions</div>
                      <div className="m_prod_desc">
                        Premium access plan
                      <span className="t_b2_px t_b2_px--link" />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="x_angles4" />
                <div className="m_prod_ctas">
                  <div className="m_prod_cta1">
                    <div className="m_prod_link0">
                      <div className="m_prod_link_ico w-embed">
                        <svg width={17} height={16} viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path fillRule="evenodd" clipRule="evenodd" d="M15.3615 7.03238L10.3291 2L9.52481 2.80429L13.9984 7.27783H0V8.27783H14.116L9.52481 12.8691L10.3291 13.6733L16.1705 7.83198L15.3662 7.02769L15.3615 7.03238Z" fill="#0073F7" />
                        </svg>
                      </div>
                      <div className="m_prod_link">Self Integrate</div>
                    </div>
                  </div>
                  <div className="m_prod_cta1">
                    <div className="m_prod_link0">
                      <div className="m_prod_link_ico w-embed">
                        <svg width={17} height={16} viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path fillRule="evenodd" clipRule="evenodd" d="M15.3615 7.03238L10.3291 2L9.52481 2.80429L13.9984 7.27783H0V8.27783H14.116L9.52481 12.8691L10.3291 13.6733L16.1705 7.83198L15.3662 7.02769L15.3615 7.03238Z" fill="#0073F7" />
                        </svg>
                      </div>
                      <div className="m_prod_link">Documentation</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="m_prod_card">
              <div className="m_prod_card1">
                <div className="m_prod_cta1">
                  <div className="m_prod_name">
                    <div className="m_prod_ico">
                      <img src="https://assets.website-files.com/5b1f8af32d51d9c88592d929/5d78eb5db23a5f2aaa2ab07e_store_icon.svg" width={30} height={30} />
                    </div>
                    <div className="m_prod">
                      <div className="m_prod_title">In-Game Store</div>
                      <div className="m_prod_desc">
                        Sell everything everywhere
                      <span className="t_b2_px t_b2_px--link" />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="x_angles4" />


                {<div className="m_prod_ctas">
                  <div className="m_prod_cta1">
                    <div className="m_prod_link0">
                      <div className="m_prod_link_ico w-embed">
                        <svg width={17} height={16} viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path fillRule="evenodd" clipRule="evenodd" d="M15.3615 7.03238L10.3291 2L9.52481 2.80429L13.9984 7.27783H0V8.27783H14.116L9.52481 12.8691L10.3291 13.6733L16.1705 7.83198L15.3662 7.02769L15.3615 7.03238Z" fill="#0073F7" />
                        </svg>
                      </div>
                      <div className="m_prod_link">Self Integrate</div>
                    </div>
                  </div>
                  <div className="m_prod_cta1">
                    <div className="m_prod_link0">
                      <div className="m_prod_link_ico w-embed">
                        <svg width={17} height={16} viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path fillRule="evenodd" clipRule="evenodd" d="M15.3615 7.03238L10.3291 2L9.52481 2.80429L13.9984 7.27783H0V8.27783H14.116L9.52481 12.8691L10.3291 13.6733L16.1705 7.83198L15.3662 7.02769L15.3615 7.03238Z" fill="#0073F7" />
                        </svg>
                      </div>
                      <div className="m_prod_link">Documentation</div>
                    </div>
                  </div>
                </div>
}

              </div>
            </div>
            <div className="m_prod_card">
              <div className="m_prod_card1">
                <div className="m_prod_cta1">
                  <div className="m_prod_name">
                    <div className="m_prod_ico">
                      <img src="https://assets.website-files.com/5b1f8af32d51d9c88592d929/5d78eaaf69cf353c5c015914_ps_icon.svg" width={30} height={30} />
                    </div>
                    <div className="m_prod">
                      <div className="m_prod_title">Pay Station</div>
                      <div className="m_prod_desc">All payment types</div>
                    </div>
                  </div>
                </div>
                <div className="x_angles4" />
                <div className="m_prod_ctas">
                  <div className="m_prod_cta1">
                    <div className="m_prod_link0">
                      <div className="m_prod_link_ico w-embed">
                        <svg width={17} height={16} viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path fillRule="evenodd" clipRule="evenodd" d="M15.3615 7.03238L10.3291 2L9.52481 2.80429L13.9984 7.27783H0V8.27783H14.116L9.52481 12.8691L10.3291 13.6733L16.1705 7.83198L15.3662 7.02769L15.3615 7.03238Z" fill="#0073F7" />
                        </svg>
                      </div>
                      <div className="m_prod_link">Self Integrate</div>
                    </div>
                  </div>
                  <div className="m_prod_cta1">
                    <div className="m_prod_link0">
                      <div className="m_prod_link_ico w-embed">
                        <svg width={17} height={16} viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path fillRule="evenodd" clipRule="evenodd" d="M15.3615 7.03238L10.3291 2L9.52481 2.80429L13.9984 7.27783H0V8.27783H14.116L9.52481 12.8691L10.3291 13.6733L16.1705 7.83198L15.3662 7.02769L15.3615 7.03238Z" fill="#0073F7" />
                        </svg>
                      </div>
                      <div className="m_prod_link">Documentation</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="m_prod_card">
              <div className="m_prod_card1">
                <div className="m_prod_cta1">
                  <div className="m_prod_name">
                    <div className="m_prod_ico">
                      <img src="https://assets.website-files.com/5b1f8af32d51d9c88592d929/5d78ead512506814a783e298_af_icon.svg" width={30} height={30} />
                    </div>
                    <div className="m_prod">
                      <div className="m_prod_title">Anti-fraud</div>
                      <div className="m_prod_desc">Ironclad security</div>
                    </div>
                  </div>
                </div>
                <div className="x_angles4" />
                <div className="m_prod_ctas">
                  <div className="m_prod_cta1">
                    <div className="m_prod_link0">
                      <div className="m_prod_link_ico w-embed">
                        <svg width={17} height={16} viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path fillRule="evenodd" clipRule="evenodd" d="M15.3615 7.03238L10.3291 2L9.52481 2.80429L13.9984 7.27783H0V8.27783H14.116L9.52481 12.8691L10.3291 13.6733L16.1705 7.83198L15.3662 7.02769L15.3615 7.03238Z" fill="#0073F7" />
                        </svg>
                      </div>
                      <div className="m_prod_link">Self Integrate</div>
                    </div>
                  </div>
                  <div className="m_prod_cta1">
                    <div className="m_prod_link0">
                      <div className="m_prod_link_ico w-embed">
                        <svg width={17} height={16} viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path fillRule="evenodd" clipRule="evenodd" d="M15.3615 7.03238L10.3291 2L9.52481 2.80429L13.9984 7.27783H0V8.27783H14.116L9.52481 12.8691L10.3291 13.6733L16.1705 7.83198L15.3662 7.02769L15.3615 7.03238Z" fill="#0073F7" />
                        </svg>
                      </div>
                      <div className="m_prod_link">Documentation</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>


        {alsoLinks && <div className="m_prod_also0">
          <div className="m_prod_card m_prod_card--2">
            <div>
              <div className="x_grid_product x_grid_product--2">
                <div className="m_prod_name">
                  <div className="m_prod_title">Xsolla Funding club</div>
                  <div className="m_prod_desc">
                    Self-publish your video game
                </div>
                </div>
              </div>
            </div>
          </div>
          <div className="m_prod_card m_prod_card--2">
            <div>
              <div className="x_grid_product x_grid_product--2">
                <div className="m_prod_name">
                  <div className="m_prod_title">Business Engine</div>
                  <div className="m_prod_desc">
                    Industry expertise and tech solutions that meet your
                    company’s needs.
                </div>
                </div>
              </div>
            </div>
          </div>
          <div className="m_prod_card m_prod_card--2">
            <div>
              <a href="https://portfolio.xsolla.com" className="x_grid_product x_grid_product--2 w-inline-block">
                <div className="m_prod_title">See our work</div>
              </a>
            </div>
          </div>
        </div>}


      </div>
    </div>
    <div data-menu="target" className="m_top" />
  </div>);
};
